import axios from "axios";
import firebase from "firebase";

const paymentsApiService = {

  async getMonthly(startDate, endDate) {
    const userIdToken = await firebase.auth().currentUser.getIdToken(true);
    const endpoint = `/api/payment/monthly/breakdown?start_date=${startDate}&end_date=${endDate}`;

    return new Promise((resolve, reject) => {
      axios.get(endpoint, { headers: { "Authorization": userIdToken } })
        .then((response) => resolve(response.data.payment))
        .catch((reason) => reject(new Error("Monthly Earnings Breakdown API Error. " + reason.message)));
    });
  },

  async getDaily(startDate, endDate) {
    const userIdToken = await firebase.auth().currentUser.getIdToken(true);
    const endpoint = `/api/payment/daily/breakdown?start_date=${startDate}&end_date=${endDate}`;

    return new Promise((resolve, reject) => {
      axios.get(endpoint, { headers: { "Authorization": userIdToken } })
        .then((data) => resolve(data.data.payment))
        .catch((reason) => reject(new Error("Daily Earnings Breakdown API Error. " + reason.message)));
    });
  }
};

export default paymentsApiService;